import { render, staticRenderFns } from "./notification_not_set.vue?vue&type=template&id=965ad10e&scoped=true&"
import script from "./notification_not_set.vue?vue&type=script&lang=js&"
export * from "./notification_not_set.vue?vue&type=script&lang=js&"
import style0 from "./notification_not_set.vue?vue&type=style&index=0&id=965ad10e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965ad10e",
  null
  
)

export default component.exports